import React from "react";
import { Card, Table , Button} from "reactstrap";
import { getFilterTypeValue } from "./util";
import { CREDIT_TERMS_DAYS, CREDIT_TERMS_DAYS_DESCRIPTION } from '../constants';

class CreditTermTable extends React.Component {

    state = { selectedMonthFilter: undefined, filteredData: {} }

    componentDidMount() {
        //console.log(this.props);
    }

    handleMonthFilter = (e) => {
        if (this.state.selectedMonthFilter !== e.target.value) {
            this.setState({ selectedMonthFilter: e.target.value }, () => {
                this.filterData();
            })
        }
        e.preventDefault();
    }

    filterData = () => {
        let filteredData = {}
        this.props.creditTermDays.filter(element => {
            if (element.month == this.state.selectedMonthFilter) {
                filteredData = { ...filteredData, [element.type]: element }
            }
        });
        this.setState({ filteredData: filteredData }, () => {
            //console.log(this.state);
        })
    }

    componentDidUpdate(prevProps) {
        if (prevProps.creditTermDays !== this.props.creditTermDays) {
            this.setState({ selectedMonthFilter: this.props.monthfilters[0] }, () => {
                this.filterData();
            })
        }
    }

    render() {
        return (<Card body className='mt-3' >

            <div>
                <h3 className='text-center'>
                    {CREDIT_TERMS_DAYS}
                </h3>

                {
                    this.props.monthfilters
                    && this.props.monthfilters.length > 0
                    && <select className='position-absolute chart-filter-dropdown' name="monthfilter" onChange={(e) => this.handleMonthFilter(e)} value={this.state.selectedMonthFilter}>
                        {this.props.monthfilters.map((optionValue, index) => (<option key={index} value={optionValue} >{optionValue}</option>))}
                    </select>
                }
            </div>

            {
            this.state.filteredData 
            && <div>
                <Table bordered>
                    <thead>
                        <tr>
                            <th className="cug-risk-table-th" rowSpan="2"> Particulars </th>
                            <th className="cug-risk-table-th" rowSpan="2"> With Me </th>
                            <th className="cug-risk-table-th" colSpan="2"> With Other CUG Members </th>
                        </tr>
                        <tr>
                            <th className="cug-risk-table-th" > Minimum </th>
                            <th className="cug-risk-table-th" > Maximum </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th className="cug-risk-table-th" scope="row">Finished Jewelry Sale</th>
                            <td className="cug-risk-table-tr">{this.state.filteredData["JEWELRY_SALE"] && this.state.filteredData["JEWELRY_SALE"].myCreditDays}</td>
                            <td className="cug-risk-table-tr" >{this.state.filteredData["JEWELRY_SALE"] && this.state.filteredData["JEWELRY_SALE"].minOthersCreditDays}</td>
                            <td className="cug-risk-table-tr" >{this.state.filteredData["JEWELRY_SALE"]&& this.state.filteredData["JEWELRY_SALE"].maxOthersCreditDays}</td>
                        </tr>
                        <tr>
                            <th className="cug-risk-table-th" scope="row">Job Work</th>
                            <td className="cug-risk-table-tr" >{this.state.filteredData["JOB_WORK"] && this.state.filteredData["JOB_WORK"].myCreditDays}</td>
                            <td className="cug-risk-table-tr" >{this.state.filteredData["JOB_WORK"] && this.state.filteredData["JOB_WORK"].minOthersCreditDays}</td>
                            <td className="cug-risk-table-tr" >{this.state.filteredData["JOB_WORK"] && this.state.filteredData["JOB_WORK"].maxOthersCreditDays}</td>
                        </tr>
                        <tr>
                            <th className="cug-risk-table-th" scope="row">Loose Diamond Sale</th>
                            <td className="cug-risk-table-tr" >{this.state.filteredData["DIAMOND_SALES"] && this.state.filteredData["DIAMOND_SALES"].myCreditDays}</td>
                            <td className="cug-risk-table-tr" >{this.state.filteredData["DIAMOND_SALES"] && this.state.filteredData["DIAMOND_SALES"].minOthersCreditDays}</td>
                            <td className="cug-risk-table-tr" >{this.state.filteredData["DIAMOND_SALES"] && this.state.filteredData["DIAMOND_SALES"].maxOthersCreditDays}</td>
                        </tr>
                    </tbody>
                </Table>
            
                <details>
                    <summary>
                        <i>Know more...</i>
                    </summary>
                    <p dangerouslySetInnerHTML={{ __html: CREDIT_TERMS_DAYS_DESCRIPTION }}></p>
                </details>
            </div>
          }

        </Card>)
    }
}

export default CreditTermTable;